var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14645 12.6225L11.4393 7.99903C11.6346 7.78873 11.9512 7.78873 12.1464 7.99903L12.8498 8.75658C13.0449 8.96667 13.0451 9.30722 12.8503 9.5176L9.62289 13.0033L12.8503 16.4889C13.0451 16.6993 13.0449 17.0398 12.8498 17.2499L12.1464 18.0075C11.9512 18.2178 11.6346 18.2178 11.4393 18.0075L7.14645 13.384C6.95118 13.1737 6.95118 12.8328 7.14645 12.6225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9394 12.6225L16.2323 7.99903C16.4276 7.78873 16.7442 7.78873 16.9394 7.99903L17.6428 8.75658C17.8379 8.96667 17.8381 9.30722 17.6433 9.5176L14.4159 13.0033L17.6433 16.4889C17.8381 16.6993 17.8379 17.0398 17.6428 17.2499L16.9394 18.0075C16.7442 18.2178 16.4276 18.2178 16.2323 18.0075L11.9394 13.384C11.7442 13.1737 11.7442 12.8328 11.9394 12.6225Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCaretLeft);
export default __webpack_public_path__ + "static/media/double-caret-left.f2f3b81d.svg";
export { ForwardRef as ReactComponent };